<template>
  <div class="content">
    <!-- 页面标题 -->
    <div v-wechat-title="'提灯与地下城'"></div>
    <div class="top" ref="top"></div>
    <!-- 移动端 -->
    <div id="main-mobile" style="min-width: 320px; max-width: 540px;" ref="mobile">
      <!-- 头部 -->
      <header :class="'header-login-' + headerLogin">
        <div class="acco">{{ user_info.user_id ? `${user_info.role_name} ${user_info.server_name ?
          `[${user_info.server_name}]` : ''}` : '新版预约' }}</div>
        <a class="download-btn" title="下载按钮" @click="goOfficeWeb"></a>
        <a v-if="!user_info.user_id" class="logon-btn" @click="logon()" title="登录&切换按钮"></a>
        <a v-if="user_info.user_id && userInfo.os !== 'bilibili'" class="switch-btn" @click="switchBtn()"></a>
        <a v-if="user_info.user_id && userInfo.os == 'bilibili'" class="logout-btn" @click="qhBtn()"></a>
      </header>

      <div class="content_01">
        <img class="animated zoomInDown" src="https://download4.qcplay.com/tideng/ani-appoint/home/slogan.png" />
        <div class="light-eye"></div>
        <div class="red-light"></div>
        <div class="reward-container">
          <div class="reward-1"></div>
          <div class="reward-2"></div>
          <div class="reward-3"></div>
          <div class="reward-4"></div>
          <div class="button-container"></div>
          <template v-if="!isSXTimePassed()">
            <div v-if="is_book == 0" class="appoint-btn" @click="appoint"></div>
            <div v-else class="appoint-success" @click="appointSuccess"></div>
          </template>

          <!-- 时间过期后的新逻辑 -->
          <template v-else>
            <!-- 这里放时间过期后要显示的内容 -->
            <div v-if="is_book == 0 && is_send == 0" class="new-appoint-btn" @click="appoint"></div>
            <div v-if="is_book == 1 && is_send == 0" class="appoint-successed" @click="appointSuccessed"></div>
            <div v-if="is_book == 1 && is_send == 1" class="new-appoint-success" @click="appointSuccess"></div>
          </template>

          <div class="text-tip" :style="{ backgroundImage: 'url(' + textTip + ')' }"></div>
        </div>
      </div>

      <div class="content_02">
        <div class="tengman"></div>
        <div class="shake-light" :class="{ 'no-animation': cai_dan_get }" @click="getEggReward">
        </div>
        <div class="arrow"></div>
        <div class="banben-title"></div>
        <div class="lunbo-container">
          <div class="gallery">
            <div class="image-container">
            </div>
            <img :src="images[selectedIndex]" :class="{ 'large-image': true }"
              @click="toggleFullscreen(selectedIndex)" />
            <!-- 缩略图列表 -->
            <div class="thumbnails">
              <img v-for="(image, index) in smallImage" :key="`thumb_${index}_${index === selectedIndex}`"
                :src="index === selectedIndex ? suolianImage[index] : image" :class="[
                  `thumbnail-${index}`,
                  {
                    'thumbnail': true,
                    'selected': index === selectedIndex
                  }]" @click="changeImage(index)" />
            </div>
          </div>
        </div>
      </div>

      <div class="content_03" ref="targetSection">
        <div class="buttble-box">
          <div class="buttble"
            style="width:24px; height:24px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:1.67501s, 1.67501s; -webkit-animation-duration:8.0649s, 8.0649s; -moz-animation-name:fade, rightTop; -moz-animation-delay:1.67501s, 1.67501s; -moz-animation-duration:8.0649s, 8.0649s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot01.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.96199s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.96199s;" />
          </div>
          <div class="buttble"
            style="width:36px; height:36px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:1.47375s, 1.47375s; -webkit-animation-duration:10.85969s, 10.85969s; -moz-animation-name:fade, rightTop; -moz-animation-delay:1.47375s, 1.47375s; -moz-animation-duration:10.85969s, 10.85969s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.39094s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.39094s;" />
          </div>
          <div class="buttble"
            style="width:50px; height:50px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.3837s, 2.3837s; -webkit-animation-duration:7.31807s, 7.31807s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.3837s, 2.3837s; -moz-animation-duration:7.31807s, 7.31807s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>
          <div class="buttble"
            style="width:60px; height:60px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.0s, 2.0s; -webkit-animation-duration:5.7361s, 5.7361s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.0s, 2.0s; -moz-animation-duration:5.7361s, 5.7361s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot01.png"
              style="-webkit-animation-name:clockwiseSpin; -webkit-animation-duration:4.10997s; -moz-animation-name:clockwiseSpin; -moz-animation-duration:4.10997s;" />
          </div>
          <div class="buttble"
            style="width:80px; height:80px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.08319s, 2.08319s; -webkit-animation-duration:12.834s, 12.834s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.08319s, 2.08319s; -moz-animation-duration:12.834s, 12.834s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:11.50401s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:11.50401s;" />
          </div>
          <div class="buttble"
            style="width:50px; height:50px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.67501s, 2.67501s; -webkit-animation-duration:10.0649s, 10.0649s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.67501s, 2.67501s; -moz-animation-duration:10.0649s, 10.0649s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot01.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.96199s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.96199s;" />
          </div>
          <div class="buttble"
            style="width:12px; height:12px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.47375s, 2.47375s; -webkit-animation-duration:12.85969s, 12.85969s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.47375s, 2.47375s; -moz-animation-duration:12.85969s, 12.85969s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.39094s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.39094s;" />
          </div>
          <div class="buttble"
            style="width:35px; height:35px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.3837s, 2.3837s; -webkit-animation-duration:14.31807s, 14.31807s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.3837s, 2.3837s; -moz-animation-duration:14.31807s, 14.31807s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>
          <div class="buttble"
            style="width:5px; height:5px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.67501s, 2.67501s; -webkit-animation-duration:10.0649s, 10.0649s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.67501s, 2.67501s; -moz-animation-duration:10.0649s, 10.0649s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot01.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.96199s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.96199s;" />
          </div>
          <div class="buttble"
            style="width:12px; height:12px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.47375s, 2.47375s; -webkit-animation-duration:12.85969s, 12.85969s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.47375s, 2.47375s; -moz-animation-duration:12.85969s, 12.85969s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.39094s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.39094s;" />
          </div>
          <div class="buttble"
            style="width:15px; height:15px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.3837s, 2.3837s; -webkit-animation-duration:14.31807s, 14.31807s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.3837s, 2.3837s; -moz-animation-duration:14.31807s, 14.31807s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>
          <div class="buttble"
            style="width:100px; height:100px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:3.67501s, 3.67501s; -webkit-animation-duration:8.0649s, 8.0649s; -moz-animation-name:fade, rightTop; -moz-animation-delay:3.67501s, 3.67501s; -moz-animation-duration:8.0649s, 8.0649s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot01.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.96199s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.96199s;" />
          </div>
          <div class="buttble"
            style="width:120px; height:120px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.3837s, 2.3837s; -webkit-animation-duration:7.31807s, 7.31807s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.3837s, 2.3837s; -moz-animation-duration:7.31807s, 7.31807s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>

          <div class="buttble"
            style="width:70px; height:70px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.08319s, 2.08319s; -webkit-animation-duration:12.0649s, 12.0649s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.08319s, 2.08319s; -moz-animation-duration:12.0649s, 12.0649s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot01.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:6.96199s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:6.96199s;" />
          </div>
          <div class="buttble"
            style="width:20px; height:20px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.3837s, 2.3837s; -webkit-animation-duration:8.85969s, 8.85969s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.3837s, 2.3837s; -moz-animation-duration:8.85969s, 8.85969s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:6.39094s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:6.39094s;" />
          </div>
          <div class="buttble"
            style="width:60px; height:60px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:1.47375s, 1.47375s; -webkit-animation-duration:7.31807s, 7.31807s; -moz-animation-name:fade, leftTop; -moz-animation-delay:1.47375s, 1.47375s; -moz-animation-duration:7.31807s, 7.31807s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>
          <div class="buttble"
            style="width:40px; height:40px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.58805s, 2.58805s; -webkit-animation-duration:4.7361s, 4.7361s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.58805s, 2.58805s; -moz-animation-duration:4.7361s, 4.7361s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot01.png"
              style="-webkit-animation-name:clockwiseSpin; -webkit-animation-duration:3.10997s; -moz-animation-name:clockwiseSpin; -moz-animation-duration:3.10997s;" />
          </div>
          <div class="buttble"
            style="width:30px; height:30px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:1.67501s, 1.67501s; -webkit-animation-duration:6.834s, 6.834s; -moz-animation-name:fade, leftTop; -moz-animation-delay:1.67501s, 1.67501s; -moz-animation-duration:6.834s, 6.834s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:5.50401s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:5.50401s;" />
          </div>
          <div class="buttble"
            style="width:50px; height:50px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.47375s, 2.47375s; -webkit-animation-duration:10.31807s, 10.31807s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.47375s, 2.47375s; -moz-animation-duration:10.31807s, 10.31807s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>
          <div class="buttble"
            style="width:30px; height:30px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.58805s, 2.58805s; -webkit-animation-duration:12.7361s, 12.7361s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.58805s, 2.58805s; -moz-animation-duration:12.7361s, 12.7361s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot01.png"
              style="-webkit-animation-name:clockwiseSpin; -webkit-animation-duration:3.10997s; -moz-animation-name:clockwiseSpin; -moz-animation-duration:3.10997s;" />
          </div>
          <div class="buttble"
            style="width:15px; height:15px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.67501s, 2.67501s; -webkit-animation-duration:14.834s, 14.834s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.67501s, 2.67501s; -moz-animation-duration:14.834s, 14.834s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:5.50401s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:5.50401s;" />
          </div>
          <div class="buttble"
            style="width:5px; height:5px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.47375s, 2.47375s; -webkit-animation-duration:10.31807s, 10.31807s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.47375s, 2.47375s; -moz-animation-duration:10.31807s, 10.31807s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>
          <div class="buttble"
            style="width:80px; height:80px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.58805s, 2.58805s; -webkit-animation-duration:12.7361s, 12.7361s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.58805s, 2.58805s; -moz-animation-duration:12.7361s, 12.7361s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot01.png"
              style="-webkit-animation-name:clockwiseSpin; -webkit-animation-duration:3.10997s; -moz-animation-name:clockwiseSpin; -moz-animation-duration:3.10997s;" />
          </div>
          <div class="buttble"
            style="width:65px; height:65px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.67501s, 2.67501s; -webkit-animation-duration:14.834s, 14.834s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.67501s, 2.67501s; -moz-animation-duration:14.834s, 14.834s;">
            <img src="https://download4.qcplay.com/tideng/ani-appoint/home/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:5.50401s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:5.50401s;" />
          </div>
        </div>
        <div v-for="n in 10" :key="n" :class="`bf_${n}`"></div>
        <div class="reward-list"></div>
        <div class="big-reward"></div>
      </div>

      <div class="content_04">
        <!-- 抽奖机 -->
        <div class="rule-btn" @click="clickRule"></div>
        <div class="main">
          <div class="draw-box">
            <div class="draw-list">
              <ul :class="'ul-' + randomNumber">
                <li :class="'li-' + item.id" v-for="(item, index) in drawList" :key="index"></li>
              </ul>
            </div>
          </div>
          <div class="reward-count">
            <p class="left-text">剩余抽奖次数:</p>
            <p class="right-text">{{ times }}</p>
          </div>
          <div class="light-line"></div>
          <div class="left-btn" @click="showReWardList"></div>
          <div class="right-btn" @click="showTaskList">
            <div class="red-dot" v-if="showRedDot && user_info.user_id"></div>
          </div>
          <div class="lottery-btn" :class="{ 'active': isDrawing }" @click="debouncedLotteryBtn"></div>
        </div>
      </div>
      <!-- 周年庆特色 -->
      <div class="content_05">
      </div>
      <!-- 大图弹窗 -->
      <div class="full-wrap popup_wrap" v-show="showFullscreen">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="full-wrap-box">
            <img :src="BigImages[selectedIndex]" class="fullscreen-image" />
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('showFullscreen', false)"></div>
      </div>

      <!-- 彩蛋弹窗 -->
      <div class="egg-wrap popup_wrap" v-show="eggShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="egg-wrap-box popup_wrap-box" v-show="eggShow">
            <div class="confirm-btn" @click="popSwitch('eggShow', false)"></div>
            <div class="close-btn" @click="popSwitch('eggShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('eggShow', false)"></div>
      </div>

      <!-- 规则弹窗 -->
      <div class="rule-wrap popup_wrap" v-show="ruleShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="rule-box popup_wrap-box" v-show="ruleShow">
            <div class="confirm-btn" @click="popSwitch('ruleShow', false)"></div>
            <div class="close-btn" @click="popSwitch('ruleShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('ruleShow', false)"></div>
      </div>

      <!-- 没有礼物弹窗弹窗 -->
      <div class="no-reward-wrap popup_wrap" v-show="noReWardShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="no-reward-box popup_wrap-box" v-show="noReWardShow">
            <div class="confirm-btn" @click="popSwitch('noReWardShow', false)"></div>
            <div class="close-btn" @click="popSwitch('noReWardShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('noReWardShow', false)"></div>
      </div>

      <!-- 预约成功弹窗 -->
      <div class="appoint-wrap popup_wrap" v-show="appointShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="appoint-box popup_wrap-box" v-show="appointShow">
            <div class="confirm-btn" @click="popSwitch('appointShow', false)"></div>
            <div class="close-btn" @click="popSwitch('appointShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('appointShow', false)"></div>
      </div>

      <!-- 注销弹窗 -->
      <div class="logout-wrap popup_wrap" v-show="logoutShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="logout-box popup_wrap-box" v-show="logoutShow">
            <p>是否退出当前账号</p>
            <a class="left-btn" href="javascript:;" @click="logoutShow = false">取消</a>
            <a class="right-btn" href="javascript:;" @click="logoutBtn()">确定</a>
          </div>
        </transition>
      </div>

      <!-- 好友进入弹窗 -->
      <div class="add-friend-wrap popup_wrap" v-show="addFriendShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="add-friend-box popup_wrap-box" :style="{ backgroundImage: 'url(' + addFriendBoxBg + ')' }"
            v-show="addFriendShow">
            <div class="light-eye"></div>
            <div class="red-light"></div>
            <div class="download" @click="clickDownload"></div>
            <div class="go-to" @click="goToHair" :style="{ backgroundImage: 'url(' + goToBg + ')' }"></div>
          </div>
        </transition>
      </div>
      <!-- 好友进入弹窗 -->
      <!-- <div class="add-friend-wrap popup_wrap" v-show="addFriendShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="add-friend-box popup_wrap-box" v-show="addFriendShow">
            <div class="light-eye"></div>
            <div class="red-light"></div>
            <div class="download" @click="clickDownload"></div>
            <div class="go-to" @click="goToHair"></div>
          </div>
        </transition>
      </div> -->

      <!-- 邀请好友弹窗 -->
      <div class="friend-wrap popup_wrap" v-show="friendShow" style="position: fixed; overflow: hidden;">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="friend-box popup_wrap-box" v-show="friendShow">
            <div class="light-eye"></div>
            <div class="red-light"></div>
            <div class="clipboard-btn" @click="copyLink('.clipboard-btn')" data-event="复制活动链接"
              :data-clipboard-text="`【提灯与地下城】四周年庆典&全新版本预约！幸运抽奖机限时开启，8888钻石惊喜等您赢取！https://h5.qingcigame.com/tideng/ani-appoint/enter?help_id=${help_id}`">
            </div>
            <div class="close-btn" @click="popSwitch('friendShow', false)"></div>
            <div class="current-time">当前抽奖机会: {{ times }}</div>
            <div class="confirm-btn" @click="popSwitch('friendShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('friendShow', false)"></div>
      </div>

      <!-- 登录弹窗 -->
      <Login v-if='isShowLogin' @child-event="handleClose" noAuthLogin v-on:channelCallback='onBind()'
        :gameName="gameName" :loginTypes='loginTypes' :downloadUrl='downloadUrl' channelTips='角色UID可在游戏中—设置—UID查看'>
      </Login>

      <!-- 绑定弹窗 -->
      <Os v-if='isShowOs' v-on:selectCallback='onBind()' v-on:logoutCallback='osCancel' :gameName='gameName'></Os>

      <!-- 抽奖弹窗 -->
      <div v-for="i in 9" :key="i">
        <div :class="'reward-wrap-' + i + ' popup_wrap reward-wrap-' + rewards[i]" v-show="rewards[i]">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="reward-box popup_wrap-box" v-show="rewards[i]">
              <div class="confirm-btn" @click="popRewardSwitch(i, false)"></div>
              <div class="close-btn" @click="popRewardSwitch(i, false)"></div>
            </div>
          </transition>
          <div class="close-bg" @click="popRewardSwitch(i, false)"></div>
        </div>
      </div>

      <!-- 奖励信息弹窗 -->
      <div :class="'reward-list-wrap popup_wrap reward-list-wrap-' + rewardListShow" v-show="rewardListShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
          :duration="{ enter: 1000 }">
          <div class="reward-list-box popup_wrap-box" v-show="rewardListShow">
            <div class="list">
              <div v-if="record_list.length == 0">暂无数据</div>
              <ul v-else>
                <li v-for="(item, index) in record_list" :key="index"><span>{{ item.updated_at }}</span><span>{{
                  item.remark
                    }}</span></li>
              </ul>
            </div>
            <div class="confirm-btn" @click="popSwitch('rewardListShow', false)"></div>
            <div class="close-btn" @click="popSwitch('rewardListShow', false)"></div>
          </div>
        </transition>
      </div>

      <!-- 任务弹窗 -->
      <div class="task-wrap popup_wrap" v-show="taskInfoListShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="task-box popup_wrap-box" v-show="taskInfoListShow">
            <div class="lottery-count">当前抽奖机会: {{ times }}</div>
            <div class="task-list">
              <li :class="`task task-${index}`" v-for="(item, index) in task_info" :key="index">
                <div class="content-container">
                  <p v-html="highlightPlusOne(item.title)"></p>
                </div>
                <div :class="[
                  'item',
                  (item.id === 1 && item.status === 0) ? 'item-3' : `item-${item.status}`,
                  `list-${index}`,
                  { 'item-2-force': item.number >= 5 && item.id == 2 }
                ]" :key="index" @click="handleClick(item.id)"></div>
              </li>
            </div>
            <div class="confirm-btn" @click="popSwitch('taskInfoListShow', false)"></div>
            <div class="close-btn" @click="popSwitch('taskInfoListShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('taskInfoListShow', false)"></div>
      </div>
    </div>
    <Footer :gameName="gameName" />
    <div @touchmove.prevent :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Toast, Indicator } from 'mint-ui';
import { onInitAPI, onEggRewardAPI, lotteryDataAPI, appointAPI, doTaskAPI, getRewardAPI } from '../api'
import { mapState, mapMutations, mapActions } from 'vuex'
import { getTimeStamp, analysisParams, buriedLogger } from '@/utils/utils';
import Os from '@/components/os';
import Login from '../login'
import { LogoutAPI } from "@/api/login";
import Footer from '@/components/Footer';

export default {
  name: 'ani-appoint',
  components: {
    Login,
    Os,
    Footer
  },
  data() {
    return {
      now_at: '',
      loopInt: null,
      showRedDot: false,
      isReached: false,
      qwLink: '',
      gzhLink: '',
      appointShow: false,
      fireflies: [], // 萤火虫数据
      containerWidth: 0, // 必须初始化
      containerHeight: 0, // 新增高度计算

      preventShow: false,
      showFullscreen: false,
      cai_dan_get: false,
      isDrawing: false,
      is_book: '', // 是否预约成功了
      is_send: '', // 是否领取了奖励
      addFriendShow: false,
      help_id: '',
      friendShow: false, // 邀请好友弹窗
      gameNum: 0,
      friendNum: 0,
      task_info: [],
      taskInfoListShow: false,
      record_list: [], // 奖励信息
      rewardListShow: false, // 奖励信息弹窗
      rewards: Array(10).fill(false), // 初始化一个长度为10的数组，索引1-9对应reward_1到reward_9
      times: 0, // 剩余抽奖次数
      noReWardShow: false,
      ruleShow: false,
      eggShow: false,
      randomNumber: 1,  // 默认随机按钮
      drawList: [
        { id: 1, select: 1 },
        { id: 2, select: 0 },
        { id: 3, select: 0 },
        { id: 4, select: 0 },
        { id: 5, select: 0 },
        { id: 6, select: 0 },
        { id: 7, select: 0 },
        { id: 8, select: 0 },
        { id: 9, select: 0 }
      ],
      showSuolian: false,
      selectedIndex: 0, // 默认选中第一个

      addFriendBoxBg: 'https://download4.qcplay.com/tideng/ani-appoint/dialog/add_friend_pop.png',
      goToBg: 'https://download4.qcplay.com/tideng/ani-appoint/dialog/go_to.png',
      newAddFriendBoxBg: 'https://download4.qcplay.com/tideng/ani-appoint/dialog/new_add_friend_pop.png',
      newGoToBg: 'https://download4.qcplay.com/tideng/ani-appoint/dialog/new_go_to.png',
      textTip: 'https://download4.qcplay.com/tideng/ani-appoint/home/text_tip.png',
      newTextTip: 'https://download4.qcplay.com/tideng/ani-appoint/home/new_text_tip.png',

      images: [
        'https://download4.qcplay.com/tideng/ani-appoint/home/1.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/2.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/3.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/4.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/5.png',
      ],
      smallImage: [
        'https://download4.qcplay.com/tideng/ani-appoint/home/s_1.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/s_2.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/s_3.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/s_4.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/s_5.png',
      ],
      suolianImage: [
        'https://download4.qcplay.com/tideng/ani-appoint/home/l_1.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/l_2.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/l_3.png',
        '.https://download4.qcplay.com/tideng/ani-appoint/home/l_4.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/l_5.png',
      ],
      BigImages: [
        'https://download4.qcplay.com/tideng/ani-appoint/home/b_1.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/b_2.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/b_3.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/b_4.png',
        'https://download4.qcplay.com/tideng/ani-appoint/home/b_5.png',
      ],
      shareLink: "",
      gameName: 'tideng',
      downloadUrl: 'https://tideng.qingcigame.com/official/index_mobile.html',
      user_info: {}, // 用户信息
      logger: null,
      titleShow: false,
      headerLogin: false,
      loginTypes: ["sms", "password", "channel"],

      isRequesting: false, // 用于锁机制
      logoutShow: false,
    }
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  mounted() {
    this.$nextTick(() => {
      // 设置次日0点自动刷新
      this.setBackgroundTimer();
      const now = new Date();
      const night = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1
      );
      const msToMidnight = night - now;

      this.refreshTimer = setTimeout(() => {
        this.checkRedDotStatus();
      }, msToMidnight);

      this.initBatObserver()
      this.monitoringEquipment();
      this.startAutoSlide();
      const params = analysisParams(window.location.href);
      this.help_id = params.help_id
      if (this.help_id) {
        if (window.localStorage.getItem('new_help_id')) {
          this.onInit(this.help_id)
        } else {
          this.addFriendShow = true
        }
      } else {
        this.onInit(this.help_id)
      }
      var linkUrl = 'https://h5.qingcigame.com/tideng/ani-appoint/enter';
      this.isSetShare(linkUrl);
    })
  },
  beforeDestroy() {
    this.stopAutoSlide();
    this.clearTimer();
    window.removeEventListener('scroll', this.checkPosition)
  },
  created() {
    this.checkRedDotStatus();
    // 清空store上的用户数据
    this.setInitActiveInfo()
    this.setInitUserInfo()
    // 将 lotteryBtn 包装成防抖函数，500ms 内只能触发一次
    this.debouncedLotteryBtn = this.debounce(this.lotteryBtn, 350);
    const bl = buriedLogger('tideng', '提灯预约页+周年庆');
    this.logger = bl
  },
  // 在watch中监听用户ID变化
  watch: {
    'user_info.user_id': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.clearTimer(); // 切换账号时清除旧定时器
          this.setupRefreshTimer();
          this.checkRedDotStatus(); // 重新检查新账号状态
        }
      }
    }
  },
  methods: {
    setBackgroundTimer() {
      // 使用示例
      if (this.isSXTimePassed()) {
        // 上线后
        this.updateBackgrounds();
      }
    },
    isSXTimePassed() {
      const sxTime = new Date(2025, 2, 27, 9, 0, 0); // 月份从0开始

      // 解析后端时间字符串（兼容多种格式）
      const [datePart, timePart] = this.now_at.split(/[\sT]/);
      const [year, month, day] = datePart.split(/[-\/]/).map(Number);
      const [hours, minutes, seconds] = (timePart || '00:00:00').split(':').map(Number);

      // 创建本地时间对象（与sxTime保持相同时区）
      const currentTime = new Date(
        year,
        month - 1, // 月份修正
        day,
        hours,
        minutes,
        seconds
      );
      return currentTime > sxTime;
    },
    updateBackgrounds() {
      this.addFriendBoxBg = this.newAddFriendBoxBg
      this.goToBg = this.newGoToBg
      this.textTip = this.newTextTip
    },
    // 修改后的检查方法
    checkRedDotStatus() {
      try {
        const userId = this.user_info.user_id;
        if (!userId) return;

        // 使用带用户ID的存储键
        const lastClickDate = localStorage.getItem(`lottery_reddot_date_${userId}`);
        const today = new Date().toDateString();

        this.showRedDot = lastClickDate !== today;
      } catch (e) {
        this.showRedDot = true;
      }
    },

    // 修改后的隐藏方法
    hideRedDot() {
      try {
        const userId = this.user_info.user_id;
        if (!userId) return;

        const today = new Date().toDateString();
        localStorage.setItem(`lottery_reddot_date_${userId}`, today);
        this.showRedDot = false;
      } catch (e) {
        console.error('本地存储写入异常:', e);
      }
    },

    // 定时器设置方法
    setupRefreshTimer() {
      this.clearTimer();

      const now = new Date();
      const night = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1
      );
      const msToMidnight = night - now;

      this.refreshTimer = setTimeout(() => {
        this.checkRedDotStatus();
        this.setupRefreshTimer(); // 每天递归重置定时器
      }, msToMidnight);
    },

    // 清理定时器
    clearTimer() {
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = null;
      }
    },

    // 在Vue组件的methods中
    initBatObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.triggerBatAnimation(true) // 触发动画
          } else {
            this.triggerBatAnimation(false) // 可选：离开视口时重置
          }
        })
      }, {
        threshold: 0.5,
        rootMargin: "0px"  // 精确触发区域
      })

      if (this.$refs.targetSection) {
        observer.observe(this.$refs.targetSection)
      }
    },

    triggerBatAnimation(activate) {
      const bats = Array.from({ length: 10 }, (_, i) => ({
        el: this.$el.querySelector(`.bf_${i + 1}`),
        direction: (i + 1) % 2 ? 'left' : 'right'
      }));

      bats.forEach((bat, index) => {
        if (!bat.el) return;

        // 重置动画
        bat.el.style.animation = 'none';
        void bat.el.offsetWidth;

        if (activate) {
          const animationName = `batFly${bat.direction === 'left' ? 'Left' : 'Right'}`;
          bat.el.style.animation = `${animationName} ${1.5 + index * 0.2}s cubic-bezier(0.4, 0, 0.2, 1) forwards`;
        }
      });
    },
    monitoringEquipment() {
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = `https://h5.qingcigame.com/tideng/ani-appoint/pc${getTimeStamp()}`
    },
    handleClose(payload) {
      if (this.help_id) {
        this.changeLoginPopup(payload)
        this.addFriendShow = true
      } else {
        this.changeLoginPopup(payload)
      }
    },

    goToHair() {
      this.addFriendShow = false
      if (!this.isSXTimePassed()) {
        this.onToast("需要登录才能预约哦")
      }
      this.changeLoginPopup()
    },
    qhBtn() {
      this.logoutShow = true
    },
    debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, wait);
      };
    },
    // 生成萤火虫
    generateFireflies(count) {
      this.fireflies = Array.from({ length: count }, () => ({
        x: Math.random() * this.containerWidth,
        color: this.getRandomColor(),
        duration: Math.random() * 4 + 2,
        delay: Math.random() * 5
      }));
    },
    getRandomColor() {
      const colors = ["#fdd835", "#c6ff00", "#ffeb3b", "#ccff90"];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    logoutBtn() {
      LogoutAPI().then((response) => {
        if (Number(response.code) === 200) {
          // 清空数据 控制弹窗
          window.localStorage.setItem("access_token", "");
          this.osCancel()
          this.logoutShow = false
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.changeLoginPopup(true);
        }
      });
    },
    toggleFullscreen(selectedIndex) {
      const getLogMessage = (index) => {
        const ordinals = ['一', '二', '三', '四', '五']
        return `提灯预约页+周年庆_第${ordinals[index]}张版本大图的点击次数和角色数`
      }

      this.logger.sum(getLogMessage(selectedIndex))
      this.showFullscreen = !this.showFullscreen
      this.stopAutoSlide()
    },
    clickRule() {
      this.ruleShow = true
      this.logger.sum('提灯预约页+周年庆_查看活动规则的人数和角色数');
    },
    appointSuccess() {
      if (this.isSXTimePassed()) {
        this.onToast("您已经领取过奖励啦~")
      } else {
        this.onToast("您已进行过预约啦~")
      }
      this.logger.sum('提灯预约页+周年庆_预约成功后重复点击该按钮的人数和角色数');
    },
    appointSuccessed() {
      this.onInit();
      this.onToast("奖励将于5分钟内发放至邮箱")
      this.logger.sum('提灯预约页+周年庆_预约成功后重复点击该按钮的人数和角色数');
    },
    clearAllData() {
      this.is_book = ''
      this.addFriendShow = false
      this.help_id = ''
      this.friendShow = false // 邀请好友弹窗
      this.friendNum = 0
      this.task_info = []
      this.taskInfoListShow = false
      this.record_list = [] // 奖励信息
      this.rewardListShow = false // 奖励信息弹窗
      this.rewards = Array(10).fill(false) // 初始化一个长度为10的数组，索引1-9对应reward_1到reward_9
      this.times = 0 // 剩余抽奖次数
      this.noReWardShow = false
      this.ruleShow = false
      this.eggShow = false
      this.randomNumber = 1  // 默认随机按钮
      this.drawList = [
        { id: 1, select: 1 },
        { id: 2, select: 0 },
        { id: 3, select: 0 },
        { id: 4, select: 0 },
        { id: 5, select: 0 },
        { id: 6, select: 0 },
        { id: 7, select: 0 },
        { id: 8, select: 0 },
        { id: 9, select: 0 }
      ]
      this.showSuolian = false
      this.selectedIndex = 0 // 默认选中第一个
      window.localStorage.removeItem('new_help_id')
    },
    clickDownload() {
      this.logger.sum('提灯预约页+周年庆_通过分享链接点击前往冒险的次数');
      this.goLink("https://static.qcplay.com/tideng/official/")
      this.logger.sum(`提灯预约页+周年庆_参与活动页"下载游戏"按钮`);
    },
    // 前往重定向
    goLink(url) {
      if (url === '') return
      window.location.href = url
    },
    // 复制链接
    copyLink(copyName) {
      this.logger.sum('提灯预约页+周年庆_点击复制按钮的人数和角色数');
      var _this = this
      const clipboard = new Clipboard(copyName)
      clipboard.on('success', (e) => {
        _this.onToast('复制成功')
        e.clearSelection()
      })
      clipboard.on('error', (e) => {
        _this.onToast('复制失败')
      })
    },
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '叮咚！您有一封恶魔的来信！',
        imgUrl:
          'https://download4.qcplay.com/qcgame-api/m8A34pYzEDVCvMCFqyOqfiIIOgpuPGgG8pgVMugS.png',
        desc: '提灯与地下城周年狂欢，8888钻石免费抽取！今天运气爆棚，就差你助力啦，速戳',
      })
    },
    showTaskList() {
      if (!this.checkLogin()) return;

      // 点击后隐藏红点并记录状态
      this.hideRedDot();

      this.logger.sum('提灯预约页+周年庆_查看获取抽奖次数弹窗的人数和角色数');
      this.taskInfoListShow = true
    },
    handleClick(id) {
      if (this.isRequesting) return;
      this.onTask(id);
    },
    onTask(task_id) {
      if (!this.checkLogin()) return;

      const status = this.task_info[task_id - 1].status;
      switch (status) {
        case 0:
          if (this.isRequesting) return;
          this.isRequesting = true;
          const taskConfig = {
            1: { log: '每日登录活动' },
            2: { log: '邀请好友', show: 'friendShow' },
            3: {
              log: '添加企微',
              link: this.qwLink,
              ajax: true,
            },
            4: { log: '关注提灯官方公众号', link: this.gzhLink, ajax: true },
            5: {
              log: '关注提灯抖音官方号',
              link: "https://v.douyin.com/i597t3bq",
              ajax: true
            },
            6: {
              log: '关注提灯TAPTAP官方号',
              link: "https://www.taptap.cn/app/149961",
              ajax: true
            },
            7: {
              log: '关注提灯B站官方号',
              link: "https://space.bilibili.com/1856754083",
              ajax: true
            }
          };

          if (taskConfig[task_id].ajax) {
            this.doTask(task_id, taskConfig)
              .catch(() => { })
              .finally(() => {

              });
          }

          if (taskConfig[task_id]) {
            const config = taskConfig[task_id];
            this.logger.sum(`提灯预约页+周年庆_${config.log}去完成的人数和角色数`);

            if (config.show) {
              this[config.show] = true;
              this.isRequesting = false
            }
          }
          if (task_id == 1) {
            this.isRequesting = false
          }
          break;
        case 1:
          if (this.isRequesting) return;
          this.isRequesting = true;

          const taskConfig1 = {
            1: { log: '每日登录活动' },
            2: { log: '邀请好友' },
            3: {
              log: '添加企微',
            },
            4: { log: '关注提灯官方公众号' },
            5: {
              log: '关注提灯抖音官方号',
            },
            6: {
              log: '关注提灯TAPTAP官方号',
            },
            7: {
              log: '关注提灯B站官方号',
            }
          };

          if (taskConfig1[task_id]) {
            const config = taskConfig1[task_id];
            this.logger.sum(`提灯预约页+周年庆_${config.log}任务领取奖励的人数和角色数`);
          }
          this.getReward(task_id)
            .catch(() => { }) // 静默处理错误（错误已在 getReward 中提示）
            .finally(() => {
              this.isRequesting = false
              // 状态由 getReward.finally() 统一管理
            });
          break;
        case 2:
          const taskLinks = {
            3: this.qwLink,
            4: this.gzhLink,
            5: "https://v.douyin.com/BMlCJFmqlh0/",
            6: "https://www.taptap.cn/app/149961",
            7: "https://space.bilibili.com/1856754083",
          };
          // 根据 task_id 获取链接
          const link = taskLinks[task_id];
          if (link) {
            this.goLink(link);
          }
      }
    },
    getReward(task_id) {
      return getRewardAPI({ task_id })
        .then((response) => {
          if (Number(response.code) !== 200) {
            throw new Error(response.message);
          }
          return this.onInit();
        })
        .catch((error) => {
          this.onToast(error.message);
          throw error; // 继续传递错误
        });
    },
    doTask(task_id, config) {
      return doTaskAPI({ task_id })
        .then(async response => {
          if (response.code !== 200) {
            throw new Error(response.message);
          }
          await this.onInit()
          if (config[task_id].link) {
            this.goLink(config[task_id].link);
          }
        })
        .catch((error) => {
          this.onToast(error.message);
        })
        .finally(() => {
          this.isRequesting = false; // ✅ 唯一的状态重置点
        });
    },

    highlightPlusOne(title) {
      return title
        .replace(/\+1/g, '<span class="highlight">+1</span>')
        .replace(/\+3/g, '<span class="highlight">+3</span>');
    },
    appoint() {
      this.logger.sum('提灯预约页+周年庆_点击预约冒险按钮的人数和角色数');
      if (!this.user_info.user_id) {
        this.changeLoginPopup(true)
        if (!this.isSXTimePassed()) {
          this.onToast("需要登录才能预约哦")
        }
        return
      }

      // 预约逻辑
      appointAPI().then((response) => {
        if (Number(response.code) === 200) {
          this.onInit()
          if (this.isSXTimePassed()) {
            // is_book 1 is_send为0也提示这个
            this.onToast("奖励将于5分钟内发放至邮箱")
          } else {
            setTimeout(() => {
              this.appointShow = true
            }, 250);
          }
          this.logger.sum('提灯预约页+周年庆_统计预约成功的人数和角色数');
        } else {
          this.onToast(response.message)
        }
      })
    },
    // 点击抽奖按钮
    lotteryBtn() {
      // 添加抽奖状态判断
      this.logger.sum('提灯预约页+周年庆_统计立即抽奖的人数和角色数');
      // 未登录前
      if (!this.user_info.user_id) {
        if (!this.isSXTimePassed()) {
          this.onToast("完成预约即可参与活动抽奖~");
        }
        this.changeLoginPopup();
        return;
      }
      // 已登录时的处理
      if (!this.is_book) {
        if (this.isSXTimePassed()) {
          this.onToast("领取上方奖励后即可参与抽奖");
        } else {
          this.onToast("完成预约即可参与活动抽奖~");
        }
        this.$refs.top.scrollIntoView({ behavior: 'auto' });
        return;
      }
      if (this.isDrawing) return;
      this.preventShow = true
      this.isDrawing = true; // 开始抽奖时锁定
      lotteryDataAPI().then(response => {
        if (Number(response.code) === 200) {
          this.randomDrawing(response.data.prize_id);
          this.onInit();
          return
        } else {
          this.preventShow = false
        }
        this.isDrawing = false; // 异常时解锁
        this.onToast(response.message);
      }).catch((err) => {
        this.preventShow = false
        this.isDrawing = false; // 异常时解锁
        this.onToast('服务器出错啦');
      })
    },
    // 随机抽奖
    randomDrawing(prize_id) {
      let prevNum = null;
      let count = 0;
      let countMax = 20;              // 总帧数维持25次
      let interval = 100;             // 初始速度100ms/次 (约每秒10次)
      let intervalId = null;
      var _this = this;

      function getRandomNum(min, max) {
        let num = Math.floor(Math.random() * (max - min + 1)) + min;
        if (num === prevNum) return getRandomNum(min, max);
        return num;
      }

      function setRandomNum() {
        if (count === countMax) {     // 最终定格
          clearInterval(intervalId);
          _this.randomNumber = prize_id;
          setTimeout(() => {
            if (prize_id > 0) _this.popRewardSwitch(prize_id, true);
            _this.preventShow = false;
            _this.isDrawing = false;
          }, 200);
          return;
        }

        // 分阶段调速（加速->匀速->减速）
        if (count === 6) {
          clearInterval(intervalId);
          interval = 110;
          intervalId = setInterval(setRandomNum, interval);
        } else if (count === 16) {
          clearInterval(intervalId);
          interval = 160;
          intervalId = setInterval(setRandomNum, interval);
        }

        prevNum = getRandomNum(1, 9);
        _this.randomNumber = prevNum;
        count++;
      }

      intervalId = setInterval(setRandomNum, interval);
    },
    showReWardList() {
      if (!this.checkLogin()) return
      this.logger.sum('提灯预约页+周年庆_查看我的奖品弹窗的人数和角色数');
      if (this.record_list.length == 0) {
        this.noReWardShow = true
      } else {
        this.rewardListShow = true
      }
    },
    popSwitch(name, state) {
      this[name] = state;
    },
    popRewardSwitch(index, show) {
      this.$set(this.rewards, index, show);
    },
    checkLogin() {
      if (!this.user_info.user_id) {
        this.changeLoginPopup(true)
        this.onToast('请先登录')
        return false
      }
      return true
    },
    // 领取彩蛋奖励
    getEggReward() {
      if (!this.checkLogin()) return
      onEggRewardAPI().then((response) => {
        if (Number(response.code) === 200) {
          this.eggShow = true
          this.onInit()
          this.logger.sum('提灯预约页+周年庆_记录领取彩蛋人数和角色数')
        } else {
          this.onToast(response.message)
        }
      })
    },
    onBind() {
      // 切换账号
      this.clearAllData()
      const params = analysisParams(window.location.href);
      this.help_id = params.help_id
      if (this.help_id) {
        if (!this.is_book) {
          this.$refs.top.scrollIntoView({ behavior: 'auto' });
        }
        this.onInit(this.help_id)
      } else {
        if (!this.is_book) {
          this.$refs.top.scrollIntoView({ behavior: 'auto' });
        }
        this.onInit()
      }
    },
    logon() {
      if (!this.isSXTimePassed()) {
        this.changeLoginPopup(true);
        this.onToast("需要登录才能预约哦")
      } else {
        this.changeLoginPopup(true)
      }
      this.addFriendShow = false
    },
    switchBtn() {
      this.changeOsPopup(true)
    },
    // 初始化
    async onInit(help_id) {
      return await onInitAPI({ help_id }).then((response) => {
        if (Number(response.code) === 200) {
          if (help_id) {
            window.localStorage.setItem('new_help_id', help_id)
            this.logger.sum('提灯预约页+周年庆_通过分享链接完成登录进入到活动的实际人数和角色数')
          }
          this.headerLogin = true
          this.onInitDataCallback(response)
          this.setUserInfo(response.data.userInfo)
          this.now_at = response.data.activity.now_at
          this.user_info = response.data.userInfo
          this.record_list = response.data.activity.record_list // 奖品记
          this.times = response.data.activity.times
          this.help_id = response.data.userInfo.user_id
          this.task_info = response.data.activity.task_info.map((item, index) => {
            // 深拷贝避免污染原始数据
            const newItem = { ...item };

            // 处理第一个任务
            if (index === 0) {
              newItem.title = `${item.title} (${response.data.activity.task_info[0].number}/3)`;
              this.gameNum = response.data.activity.task_info[0].number;
            }
            // 处理第二个任务
            else if (index === 1) {
              newItem.title = `${item.title} (${response.data.activity.task_info[1].number}/5)`;
              this.friendNum = response.data.activity.task_info[1].number;
            }

            return newItem;
          });
          this.is_book = response.data.activity.is_book
          this.cai_dan_get = response.data.activity.cai_dan_get
          this.qwLink = response.data.activity.task_info[2].link
          this.gzhLink = response.data.activity.task_info[3].link
          if (this.isSXTimePassed()) {
            this.is_send = response.data.activity.is_send
          }
        } else {
          Number(response.code) !== 401 && this.onToast(response.message)
        }
      })
    },
    changeImage(index) {
      this.selectedIndex = index;
      const getLogMessage = (index) => {
        const ordinals = ['一', '二', '三', '四', '五']
        return `提灯预约页+周年庆_第${ordinals[index]}张版本缩略图的点击次数和角色数`
      }
      this.logger.sum(getLogMessage(this.selectedIndex))
      this.stopAutoSlide()
    },
    goOfficeWeb() {
      setTimeout(() => {
        this.logger.sum(`提灯预约页+周年庆_下载按钮点击人数`);
        window.location = this.downloadUrl;
      }, 250);
    },
    nextImage() {
      this.selectedIndex =
        (this.selectedIndex + 1) % this.images.length;
    },
    startAutoSlide() {
      this.intervalId = setInterval(this.nextImage, 2500);
    },
    stopAutoSlide() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    // 注销
    osCancel() {
      this.user_info = {}
      this.headerLogin = false
      this.clearAllData()
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },

    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setUserInfo',
      'setInitUserInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'onCount',
      'setShare'
    ])
  }
}
</script>

<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/tideng/ani-appoint/index/index.vue